import React from "react";
import styles from "../SignHeader.module.css";
import ButtonComponent from "../../../CssComponents/ButtonComponent/ButtonComponent";

const SignHeaderButtons = ({ toggleNavbar, openLogin, openRegister, isHovered, setIsHovered }) => {
    return (
        <div className={styles.headerBtns}>
            <button
                className={styles.btnLogin}
                onClick={() => {
                    openLogin();
                    toggleNavbar();
                }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                Login
            </button>


            <ButtonComponent
                className={styles.btnSignUp}
                onClick={() => {
                    openRegister();
                    toggleNavbar();
                }}
                buttonText={"Sign Up for Free"}
            />

        </div >
    );
};

export default SignHeaderButtons;
